import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';

/**
 * Public light/dark toggle, in the sidebar's «المظهر» row — available to every
 * visitor, signed in or not. Shows a moon in light mode (tap to go dark) and a
 * sun in dark mode (tap to go light). A 2.75rem target around a 1.375rem icon.
 */
export default function ThemeToggle({ className = '' }: { className?: string }) {
  const { isDark, toggle } = useTheme();
  const { t } = useTranslation('nav');

  const label = isDark ? t('theme.switchToLight') : t('theme.switchToDark');

  return (
    <button
      type="button"
      onClick={toggle}
      title={label}
      aria-label={label}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[var(--pv-color-text-muted)] transition-colors hover:bg-[rgba(0,77,64,0.06)] hover:text-[var(--pv-color-primary)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--pv-color-primary)] ${className}`}
    >
      <i className={`${isDark ? 'ri-sun-line' : 'ri-moon-line'} text-[1.375rem] leading-none`} aria-hidden="true"></i>
    </button>
  );
}
